import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import GoBack from '../../components/back/GoBack'
import { MdPayment } from 'react-icons/md'
import { AiOutlineMail,AiOutlinePhone,AiOutlinePlus,AiOutlineCloudDownload,AiOutlineEdit,AiOutlineDelete } from 'react-icons/ai'
import {CopyToClipboard} from 'react-copy-to-clipboard';
import {HiOutlineBuildingOffice} from 'react-icons/hi2';
import { toast } from 'react-hot-toast';
import moment from 'moment'
import { ButtonFilled, ButtonFilledAutoWidth, ButtonOutlinedAutoWidth } from '../../components/button'

import { DatePicker, Modal, TimePicker } from 'antd'
import { TextAreaInput1, TextInput } from '../../components/input'
import Uploader from '../../components/Uploader'
import {LuAlarmClock} from 'react-icons/lu';
import { UploadOpinionFileFile } from '../../services/OpinionFileService'
import { CreateReminderService, GetReminderService } from '../../services/ReminderService'
import { RiBillLine } from 'react-icons/ri'
import { CreateBillsService, GetBillsService } from '../../services/BillService'
import axios from 'axios'
import fileDownload from "js-file-download";
import { CreatePaymentService, GetPaymentService } from '../../services/PaymentService'
import CaseMenu from './CaseMenu'
import { DeleteActivityService, GetActivityService, UpdateActivityService } from '../../services/ActivityServices'
import { BiDirections,BiCheckbox,BiCheckboxSquare} from 'react-icons/bi';
import { CreateCaseFileAttachmentService, GetCaseFileAttachmentService } from '../../services/CaseFileAttachmentServices'

function CaseDetail() {

  const navigator = useNavigate()  

  const [data,setdata] = useState({})  
  const [step,setstep] = useState(1)  
  const [step1,setstep1] = useState(1)  
  const [visible,setvisible] = useState(false)  
  const [attachmentData,setattachmentData] = useState([])
  const [reminderData,setreminderData] = useState([])
  const [activityData,setactivityData] = useState([])

  const [selected_Activity,setselected_Activity] = useState({})
  const [updateActivity,setupdateActivity] = useState(false)
  const [bills,setbills] = useState([])
  const [payments,setpayments] = useState([])

  const [attachment,setattachment] = useState({name:'',title:'',description:'',sort:'',type:'',file:''})
  const [attachmentErr,setattachmentErr] = useState({name:'',title:'',description:'',sort:'',type:'',file:''})

  const [reminder_data,setreminder_data] = useState({title:'',date:'',time:'',description:''})
  const [reminder_data_err,setreminder_data_err] = useState({title:'',date:'',time:'',description:''})

  const [bill,setbill] = useState({file:'',amountWithGst:'',amountWithoutGst:'',completedPaymentRecieved:false,bill_id:'',bill_info:''})
  const [billErr,setbillErr] = useState({file:'',amountWithGst:'',amountWithoutGst:'',completedPaymentRecieved:'',bill_id:'',bill_info:''})

  const [payment,setpayment] = useState({bill:'',amountWithGst:'',amountWithoutGst:'',date:'',description:''})
  const [paymentErr,setpaymentErr] = useState({bill:'',amountWithGst:'',amountWithoutGst:'',date:'',description:''})


  const {state,pathname} = useLocation()
  const path1 = pathname?.split('/')[pathname?.split('/')?.length - 2]

  const [type,settype] = useState('')

  useEffect(()=>{
     setdata(state)
  },[])

  useEffect(()=>{
    getDataBasedStep()
  },[step1])


  async function getDataBasedStep(){
    if(step1 === 1){
      const response = await GetActivityService('case',state?._id)
      setactivityData(response?.data?.datas)
    }
    if(step1 === 2){
        const response = await GetReminderService(data?._id,'case')
        setreminderData(response?.data?.data)
    }
    if(step1 === 3){
        const response = await GetCaseFileAttachmentService(data?._id)
        setattachmentData(response?.data?.data)
    }
    if(step1 === 4){
        const response = await GetBillsService(data?._id,'case')
        setbills(response?.data?.data)
    }
    if(step1 === 5){
        const response = await GetPaymentService(data?._id,'case')
        setpayments(response?.data?.data)
    }
  }

  async function UploadFilefunc(e,type){
    const response = await UploadOpinionFileFile({file:e})
    if(type === 'attachment'){
        setattachment({...attachment,'file':response?.data?.data,name:response?.data?.data?.split('/')[response?.data?.data?.split('/')?.length - 1]})
    }else if(type === 'bill'){
        setbill({...bill,file:response?.data?.data})
    }
  }

  async function onChange(e){
    setreminder_data({...reminder_data,[e.target.name]:e.target.value})
    setreminder_data_err({...reminder_data_err,[e.target.name]:''})
  }

  async function onChange1(e){
    setattachment({...attachment,[e.target.name]:e.target.value})
    setattachmentErr({...attachmentErr,[e.target.name]:''})
  }

  async function onChange2(e){
    setbill({...bill,[e.target.name]:e.target.value})
    setbillErr({...billErr,[e.target.name]:''})
  }

  async function onChange3(e){
    setpayment({...payment,[e.target.name]:e.target.value})
    setpaymentErr({...paymentErr,[e.target.name]:''})
  }

  async function createreminder(){
    if(reminder_data.title === ''){
        setreminder_data_err({title:'This field is required*'});
      }else if(reminder_data.date === ''){
        setreminder_data_err({date:'This field is required*'});
      }else if(reminder_data.time === ''){
        setreminder_data_err({time:'This field is required*'});
      }else{
        let send_data = {}
        send_data['title'] = reminder_data.title 
        send_data['summary'] = reminder_data.description 
        send_data['description'] = reminder_data.description 
        
        send_data['case'] = data._id
        send_data['type'] = 'case'
  
        if(data?.date !== ''){
          send_data['on_date_time'] = reminder_data?.date1 !== undefined &&  moment(reminder_data?.date1)?.format('YYYY-MM-DD') + ' ' + reminder_data?.time1
          send_data['date'] = reminder_data?.date1
        }
  
  
        const response = await CreateReminderService(send_data)
        if(response.status === 201){
          toast.success("Reminder created successfully")
          setreminder_data({title:'',date:'',time:'',description:''})
          setvisible(false)
          setreminder_data_err({title:'',date:'',time:'',description:''})
          getDataBasedStep()
        }
    }
  }

  async function createattachmentnote(){
    if(attachment?.type === 'attachment'){
        if(!attachment?.file){
            setattachmentErr({...attachmentErr,file:'This Field is required*'})
        }else if(!attachment?.name){
            setattachmentErr({...attachmentErr,name:'This Field is required*'})
        }else{

            let send_data = {...attachment}
            delete send_data.title
            delete send_data.description

            send_data['case'] = data._id
            send_data['type'] = 'attachment'

            const response = await CreateCaseFileAttachmentService(send_data)
            if(response?.status === 201){
                getDataBasedStep()
                setattachment({name:'',title:'',description:'',sort:'',type:'',file:''})
                setattachmentErr({name:'',title:'',description:'',sort:'',type:'',file:''})
                toast.success("Attachment Added successfully!")
                setvisible(false)
            }

        }
    }else if(attachment?.type === 'notes'){
        if(!attachment?.title){
            setattachmentErr({...attachmentErr,title:'This Field is required*'})
        }else if(!attachment?.description){
            setattachmentErr({...attachmentErr,description:'This Field is required*'})
        }else{

            let send_data = {...attachment}
            delete send_data.file
            delete send_data.name
            send_data['type'] = 'notes'
            send_data['case'] = data._id

            const response = await CreateCaseFileAttachmentService(send_data)
            if(response?.status === 201){
                getDataBasedStep()
                setattachment({name:'',title:'',description:'',sort:'',type:'',file:''})
                setattachmentErr({name:'',title:'',description:'',sort:'',type:'',file:''})
                toast.success("Notes Added successfully!")
                setvisible(false)
            }

        }
    }

  }

  let rupee = new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
  });

  function returnfilename(v){
    let string = v?.split("/")[v?.split("/")?.length - 1]
    return string;
  }

  const handleDownload = (url, filename) => {
    axios.get(url, {
        responseType: 'blob',
    })
        .then((res) => {
            fileDownload(res.data, filename)
            toast.success("Attachment Downloaded") 
        })
  }

  async function createbill(){
    if(bill.file === ''){
      setbillErr({file:'This field is required*'});
    }else if(bill.amountWithGst === ''){
      setbillErr({amountWithGst:'This field is required*'});
    }else if(reminder_data.amountWithoutGst === ''){
      setbillErr({amountWithoutGst:'This field is required*'});
    }else if(reminder_data.bill_id === ''){
        setbillErr({bill_id:'This field is required*'});
    }else if(reminder_data.bill_info === ''){
        setbillErr({bill_info:'This field is required*'});
    }else{

        let send_data = {...bill}
        send_data['case'] = data._id
        send_data['type'] = 'case'

        const response = await CreateBillsService(send_data)
        if(response.status === 201){
            toast.success("Bill created successfully")
            setbill({file:'',amountWithGst:'',amountWithoutGst:'',completedPaymentRecieved:false,bill_id:'',bill_info:''})
            setvisible(false)
            setbillErr({file:'',amountWithGst:'',amountWithoutGst:'',completedPaymentRecieved:'',bill_id:'',bill_info:''})
            getDataBasedStep()
          }
    }
  }

  async function createpayment(){
    if(payment.amountWithGst === ''){
        setpaymentErr({amountWithGst:'This field is required*'});
      }else if(payment.amountWithoutGst === ''){
        setpaymentErr({amountWithoutGst:'This field is required*'});
      }else if(payment.date === ''){
        setpaymentErr({date:'This field is required*'});
      }else{
        let send_data = {...payment}
        send_data['case'] = data?._id
        send_data['client'] = data?.client?._id
        send_data['bill'] =  payment?.bill?._id
        send_data['type'] = 'case'

        const response = await CreatePaymentService(send_data)
        if(response.status === 201){
            toast.success("Payment created successfully")
            setpayment({bill:'',amountWithGst:'',amountWithoutGst:'',date:'',description:''})
            setvisible(false)
            setpaymentErr({bill:'',amountWithGst:'',amountWithoutGst:'',date:'',description:''})
            getDataBasedStep()
          }
      }

  }

  async function updateActivityStatus(){
    let send_data = {
      summary:selected_Activity?.summary,
      important:selected_Activity?.important
    }

    const response = await UpdateActivityService(selected_Activity?._id,send_data)
    if(response?.status === 200){
      toast.success("Activity Updated Successfully")
      getDataBasedStep()
      setupdateActivity(false)
      setselected_Activity({})
    }

  }

  async function deletemyactivity(a){
    const response = await DeleteActivityService(a?._id)
    if(response?.status === 200){
      getDataBasedStep()
      toast.success("Activity Deleted Successfully")
    }
  }

  async function handlechange(e){
    setselected_Activity({...selected_Activity,[e.target.name]:e.target.value})
  }


  return (
    <div className='md:h-screen pt-5 md:pt-0 md:max-h-screen md:box-border md:overflow-hidden'>

      <Modal open={visible} footer={null} closable={false} width={300}>
         <div>
           
           {(step1 === 2  && type === '') &&
           <div>
              <h6 className='font-[800]'>Add Reminder</h6>
              <h6 className='text-[11px] leading-tight bg-slate-100 p-1'>Use the below form to create the reminder for the current leads</h6>

              <TextInput label="Title" name="title" value={reminder_data?.title} error={reminder_data_err?.title} handlechange={onChange} />
              <TextAreaInput1 label="Summary" name="description" value={reminder_data?.description}  error={reminder_data_err?.description} handlechange={onChange} />
               
              <div className='flex'>
               <div>
               <h6 className='text-[11px] font-[600] mb-1' >{'Date'}</h6>
               <div className='border mr-1 border-slate-300'>
                 <DatePicker ampm={false}  inputFormat="MM/dd/yyyy" placeholder='' className='border-none ' value={reminder_data?.date} onChange={(v,v1) => {setreminder_data({...reminder_data,date:v,date1:v1});setreminder_data_err({...reminder_data_err,date:''})}} />
               </div>
               {(reminder_data_err?.date !== '' || reminder_data_err?.date  !== '')  && <h6 className='text-red-600 text-[10px]'>{reminder_data_err?.date}</h6>}
               </div> 

               <div>
               <h6 className='text-[11px] font-[600] mb-1' >{'Time'}</h6>
               <div className='border ml-1  border-slate-300'>
                 <TimePicker placeholder='' format="hh:mm"  ampm={false}  className='border-none' value={reminder_data?.time} onChange={(v,v1) => {setreminder_data({...reminder_data,time:v,time1:v1});setreminder_data_err({...reminder_data_err,time:''})}} />
               </div>
               {(reminder_data_err?.time !== '' || reminder_data_err?.time  !== '')  && <h6 className='text-red-600 text-[10px]'>{reminder_data_err?.time}</h6>}
               </div> 
               </div> 

              <div className='flex justify-end mt-3'>
                <ButtonOutlinedAutoWidth btnName="Close" onClick={()=>{setvisible(false);setreminder_data({...reminder_data,visible:false})}} />
                <div className='ml-1'>
                <ButtonFilledAutoWidth btnName="Save" onClick={()=>createreminder()} />
                </div>
              </div>
           </div>} 

           {(step1 === 3 || type === 'attachment') &&
           <div>
              <h6 className='font-[800]'>Add {attachment?.type === 'attachment' ? 'Attachment' : 'Notes'}</h6>
              <h6 className='text-[11px] leading-tight bg-slate-100 p-1'>Use the below form to create the {attachment?.type === 'attachment' ? 'Attachment' : 'Notes'} for the current opinion file</h6>

              <TextInput label="Sort" type="number" name="sort" value={attachment?.sort} error={attachmentErr?.sort} handlechange={onChange1} />

              {attachment?.type === 'notes' &&
              <>
              <TextInput label="Title" name="title" value={attachment?.title} error={attachmentErr?.title} handlechange={onChange1} />
              <TextAreaInput1 label="Summary" name="description" value={attachment?.description}  error={attachmentErr?.description} handlechange={onChange1} />
              </>}

              {attachment?.type === 'attachment' &&
              <>
              <div>
               <h6 className='text-[11px] font-[400] mt-1 mb-1' >{'Attachment'}</h6>
               <Uploader image={attachment.file} name="file" setimagefunc={(v)=>UploadFilefunc(v,'attachment')} removeimageuploadfunc={()=>setattachment({...attachment,file:''})}  />  
              
               <TextInput label="File Name" name="name" value={attachment?.name} error={attachmentErr?.name} handlechange={onChange1} />
              
              </div>
              </>}

              <div className='flex justify-end mt-3'>
                <ButtonOutlinedAutoWidth btnName="Close" onClick={()=>{setvisible(false);setattachment({name:'',title:'',description:'',sort:'',type:'',file:''})}} />
                <div className='ml-1'>
                <ButtonFilledAutoWidth btnName="Save" onClick={()=>createattachmentnote()} />
                </div>
              </div>
           </div>}

           {(step1 === 4  && type === '') &&
           <div>
              <h6 className='font-[800]'>Add Bill for your Client for the work you have done</h6>
              <h6 className='text-[11px] leading-tight bg-slate-100 p-1'>Please add the amount without gst and in description please add the details of the client like [Billing To ,Gst No , other information related to bill]</h6>


              <h6 className='text-[11px] font-[400] mt-1 mb-1' >{'Attachment'}</h6>
              <Uploader image={bill.file} name="file" setimagefunc={(v)=>UploadFilefunc(v,'bill')} removeimageuploadfunc={()=>setbill({...bill,file:''})}  />  

              <TextInput mandatory={true} type="number" label="Amount With Gst" name="amountWithGst" value={bill?.amountWithGst} error={billErr?.amountWithGst} handlechange={onChange2} />
              <TextInput mandatory={true} type="number" label="Amount Without Gst" name="amountWithoutGst" value={bill?.amountWithoutGst}  error={billErr?.amountWithoutGst} handlechange={onChange2} />
              <TextInput mandatory={true} type="text" label="Bill Id" name="bill_id" value={bill?.bill_id}  error={billErr?.bill_id} handlechange={onChange2} />
              <TextInput mandatory={true} type="date" label="Date" name="date" value={bill?.date}  error={billErr?.date} handlechange={onChange2} />
              <TextAreaInput1 mandatory={true} type="text" label="Bill Info" name="bill_info" value={bill?.bill_info}  error={billErr?.bill_info} handlechange={onChange2} />

           

              <div className='flex justify-end mt-3'>
                <ButtonOutlinedAutoWidth btnName="Close" onClick={()=>{setvisible(false);setattachment({name:'',title:'',description:'',sort:'',type:'',file:''})}} />
                <div className='ml-1'>
                <ButtonFilledAutoWidth btnName="Save" onClick={()=>createbill()} />
                </div>
              </div>
           </div>}

           {(step1 === 5 && type === '') &&
           <div>
              <h6 className='font-[800]'>Add Payment Record</h6>
              <h6 className='text-[11px] leading-tight bg-slate-100 p-1'>Please add the payment record receieved for the bill</h6>



              <TextInput mandatory={true} type="number" label="Amount With Gst" name="amountWithGst" value={payment?.amountWithGst} error={paymentErr?.amountWithGst} handlechange={onChange3} />
              <TextInput mandatory={true} type="number" label="Amount Without Gst" name="amountWithoutGst" value={payment?.amountWithoutGst}  error={paymentErr?.amountWithoutGst} handlechange={onChange3} />
              <TextInput mandatory={true} type="date" label="Date" name="date" value={payment?.date}  error={paymentErr?.date} handlechange={onChange3} />
              <TextAreaInput1 mandatory={true} type="text" label="Description" name="description" value={payment?.description}  error={paymentErr?.description} handlechange={onChange3} />

           

              <div className='flex justify-end mt-3'>
                <ButtonOutlinedAutoWidth btnName="Close" onClick={()=>{setvisible(false);setattachment({name:'',title:'',description:'',sort:'',type:'',file:''})}} />
                <div className='ml-1'>
                <ButtonFilledAutoWidth btnName="Save" onClick={()=>createpayment()} />
                </div>
              </div>
           </div>}
          
         </div>

      </Modal>


      <Modal open={updateActivity} footer={null} closable={false} width={300}>
         
         <div>
          <h6 className='text-[13px] font-[700]'>Update The <span className='font-[700]'>Selected Activity</span></h6>
          <h6 className='bg-slate-100 p-1 text-[11px] my-1 leading-[15px]'>Use the below field option to update the activity status for the selected activity</h6>
          

          <TextAreaInput1 
            label={'Summary'}  
            variant="standard"
            name="summary"
            type="text"
            value={selected_Activity.summary}
            handlechange={handlechange}
            InputLabelProps={{
                style: { color: '#fff', }, 
            }}/>

           
          <div onClick={()=>setselected_Activity({...selected_Activity,important:!selected_Activity?.important})} className='flex items-center'>
          {!selected_Activity?.important ? 
          <BiCheckbox size={22} /> :
          <BiCheckboxSquare size={22} />}
          <h6 className='text-[11px]'>Mark As Important</h6>
          </div> 

          <div className='flex border-t pt-3 justify-end mt-3'>
            <ButtonOutlinedAutoWidth btnName="Close" onClick={()=>{setupdateActivity(false);setselected_Activity({})}} />
            <div className='ml-1'>
            <ButtonFilledAutoWidth btnName="Save" onClick={()=>updateActivityStatus()} />
            </div>
          </div>
         </div>
      </Modal>

        <div className='block sm:flex'>
            <div className='md:w-44'>
            <CaseMenu />
            </div>
            <div className='pr-5 md:flex pl-5 md:w-[95%] md:min-h-screen md:max-h-screen md:h-screen md:overflow-y-scroll' >

                <div className='md:min-w-[25%] py-2 md:max-w-[25%] md:min-h-screen md:max-h-screen md:border-r'>

                    <div>
                        <div className='flex mr-4 -mt-1 items-center justify-between'>
                            <GoBack />
                            <div className='flex items-center border p-1 border-slate-300'> 
                               <span onClick={()=>navigator(`/case/${path1}/edit`,{state:data})} className='text-[8px] px-1 cursor-pointer'>Edit</span> 
                            </div>
                        </div> 

                        <div className='mt-2'>
                        <div className='grid place-items-center pt-4 -ml-4'>
                            <h6 className='bg-[#1f497a] text-white w-20 h-20 p-10 text-[22px] flex items-center justify-center uppercase rounded-full'>{data?.client?.name?.slice(0,2)}</h6>
                            <h6 className='text-[14px] mt-2 font-[900]'>{data?.client?.name}</h6>
                            <span className='text-[9.5px] font-[600] text-center'>{data?.client?.client_type}</span>
                        </div>

                        <div className='grid grid-cols-4 ml-[7%] place-items-center w-[75%] mt-2'>

                            <CopyToClipboard text={data?.client?.email} onCopy={() => toast.success('Copied to clipboard')}>
                            <div className='grid place-items-center cursor-pointer'>
                            <AiOutlineMail size={30} className='border  mx-1.5 rounded-full p-[7px] text-gray-700' />
                            <span className='text-[9px] text-gray-800 mt-1 font-[600] '>Email</span>
                            </div>
                            </CopyToClipboard>

                            <CopyToClipboard text={data?.client?.phone} onCopy={() => toast.success('Copied to clipboard')}>
                            <div className='grid place-items-center cursor-pointer'>
                            <AiOutlinePhone size={30} className='border  mx-1.5 rounded-full p-[7px] text-gray-700' />
                            <span className='text-[9px] text-gray-800 mt-1 font-[600] '>Phone</span>
                            </div>
                            </CopyToClipboard>

                            <CopyToClipboard text={data?.client?.industry?.name} onCopy={() => toast.success('Copied to clipboard')}>
                            <div className='grid place-items-center cursor-pointer'> 
                            <HiOutlineBuildingOffice size={30} className='border  mx-1.5 rounded-full p-[7px] text-gray-700' />
                            <span className='text-[9px] text-gray-800 mt-1 font-[600] '>Industry</span>
                            </div>
                            </CopyToClipboard>

                            <div className='grid place-items-center cursor-pointer' onClick={()=>{settype('attachment');setattachment({...attachment,type:'attachment'});setvisible(true)}}>
                            <AiOutlinePlus size={30} className='border  mx-1.5 rounded-full p-[7px] text-gray-700' />
                            <span className='text-[9px] text-gray-800 mt-1 font-[600] '>Attachment</span>
                            </div>

                        </div>

                        <div className='mt-2 w-[90%] ml-[3%]'>
                            <ButtonFilled btnName={JSON.stringify(data?.client?.client_type)?.toUpperCase()?.slice(1,JSON.stringify(data?.client?.client_type)?.length -1)} />
                        </div>


                            <h6 className='text-center text-[9px]  mt-2  '>Last Activity : <span className='font-[600]'> {data?.updatedAt !== undefined ? moment(data?.updatedAt?._d)?.format('lll') :  moment(data?.updatedAt)?.format('lll')}</span></h6>

                            <div className='flex items-center mr-5 mt-5 border-b'>
                                <h6 onClick={()=>setstep(1)} className={`text-[12px] cursor-pointer w-full text-center  pb-1 ${step === 1 && 'border-b-2 border-b-[#000] font-[700]'}`}>Attachment Info</h6>
                                <h6 onClick={()=>setstep(2)} className={`text-[12px] cursor-pointer w-full text-center  pb-1 ${step === 2 && 'border-b-2 border-b-[#000] font-[700]'}`}>Address Info</h6>
                            </div>

                            {step === 1 &&
                            <div className='mt-5'>

                                {data?.client?.photo &&
                                <>
                                <h6 className='text-[10px] mb-1 mt-2 font-[500] text-gray-400'>Photo</h6>
                                 <h6 className='mb-0 font-[600] underline text-[11px] text-[#1b3f69] cursor-pointer'>{data?.client?.photo?.split('/')[data?.client?.photo?.split('/')?.length -1]}</h6>
                                </>}

                                {data?.client?.aadhar_file &&
                                <>
                                <h6 className='text-[10px] mb-1 mt-2 font-[500] text-gray-400'>Aadhar File</h6>
                                 <h6 className='mb-0 font-[600] underline text-[11px] text-[#1b3f69] cursor-pointer'>{data?.client?.aadhar_file?.split('/')[data?.client?.aadhar_file?.split('/')?.length -1]}</h6>
                                </>}

                                {data?.client?.pan_file &&
                                <>
                                <h6 className='text-[10px] mb-1 mt-2 font-[500] text-gray-400'>Pan File</h6>
                                 <h6 className='mb-0 font-[600] underline text-[11px] text-[#1b3f69] cursor-pointer'>{data?.client?.pan_file?.split('/')[data?.client?.pan_file?.split('/')?.length -1]}</h6>
                                </>}

                                {data?.client?.dl_file &&
                                <>
                                <h6 className='text-[10px] mb-1 mt-2 font-[500] text-gray-400'>DL File</h6>
                                 <h6 className='mb-0 font-[600] underline text-[11px] text-[#1b3f69] cursor-pointer'>{data?.client?.dl_file?.split('/')[data?.client?.dl_file?.split('/')?.length -1]}</h6>
                                </>}

                            </div>}    

                            {step === 2 &&
                            <div className='mt-5'>
                                {data?.client?.company_name &&
                                <>
                                <h6 className='text-[10px] mb-1 mt-2 font-[500] text-gray-400'>Company Name</h6>
                                <h6 className='text-[12px] mb-0 font-[600] '>{data?.client?.company_name}</h6>
                                </>}

                                {data?.client?.address &&
                                <>
                                <h6 className='text-[10px] mb-1 mt-2 font-[500] text-gray-400'>Address</h6>
                                <h6 className='text-[12px] mb-0 font-[600] '>{data?.client?.address}</h6>
                                </>}

                                {data?.client?.aadhar_no &&
                                <>
                                <h6 className='text-[10px] mb-1 mt-2 font-[500] text-gray-400'>Aadhar No</h6>
                                <h6 className='text-[12px] mb-0 font-[600] '>{data?.client?.aadhar_no}</h6>
                                </>}

                                {data?.client?.pan_no &&
                                <>
                                <h6 className='text-[10px] mb-1 mt-2 font-[500] text-gray-400'>Pan No</h6>
                                <h6 className='text-[12px] mb-0 font-[600] '>{data?.client?.pan_no}</h6>
                                </>}

                                {data?.client?.company_name &&
                                <>
                                <h6 className='text-[10px] mb-1 mt-2 font-[500] text-gray-400'>Company Name</h6>
                                <h6 className='text-[12px] mb-0 font-[600] '>{data?.client?.company_name}</h6>
                                </>}

                                {data?.client?.secondary_name &&
                                <>
                                <h6 className='text-[10px] mb-1 mt-2 font-[500] text-gray-400'>Secondary  Name</h6>
                                <h6 className='text-[12px] mb-0 font-[600] '>{data?.client?.secondary_name}</h6>
                                </>}

                                {data?.client?.secondary_contact &&
                                <>
                                <h6 className='text-[10px] mb-1 mt-2 font-[500] text-gray-400'>Secondary Contact</h6>
                                <h6 className='text-[12px] mb-0 font-[600] '>{data?.client?.secondary_contact}</h6>
                                </>}

                                {data?.client?.comments &&
                                <>
                                <h6 className='text-[10px] mb-1 mt-2 font-[500] text-gray-400'>Comments</h6>
                                <h6 className='text-[12px] mb-0 font-[600] '>{data?.client?.comments}</h6>
                                </>}

                                <>
                                <h6 className='text-[10px] mb-1 mt-2 font-[500] text-gray-400'>Is Active</h6>
                                <h6 className='text-[12px] mb-0 font-[600] '>{data?.client?.is_active ? 'Active' : 'In Active'}</h6>
                                </>
                            </div>}
                        
                     
                     


                        </div>
                    </div>

                </div>

                <div className='md:min-w-[55%] bg-[#f9fafb] relative md:max-w-[55%] px-2'>
                    <div className='flex w-[99.6%]  sticky top-2  rounded justify-evenly px-[4px]  py-[5px]   bg-slate-200 ' >
                        <h6 onClick={()=>{setstep1(1);settype('')}} className={`px-1.5 py-1.5 w-full text-center cursor-pointer font-[600] rounded text-[11px] ${step1 === 1 ? 'bg-white text-black font-[600]' : 'text-gray-500'}`}>Activity Done</h6>
                        <h6 onClick={()=>{setstep1(2);settype('')}} className={`px-1.5 py-1.5 w-full text-center cursor-pointer font-[600] rounded text-[11px] ${step1 === 2 ? 'bg-white text-black font-[600]' : 'text-gray-500'}`}>Reminder Added</h6>
                        <h6 onClick={()=>{setstep1(3);settype('')}} className={`px-1.5 py-1.5 w-full text-center cursor-pointer font-[600] rounded text-[11px] ${step1 === 3 ? 'bg-white text-black font-[600]' : 'text-gray-500'}`}>Notes Added </h6>
                        <h6 onClick={()=>{setstep1(4);settype('')}} className={`px-1.5 py-1.5 w-full text-center cursor-pointer font-[600] rounded text-[11px] ${step1 === 4 ? 'bg-white text-black font-[600]' : 'text-gray-500'}`}>Bill Raised</h6>
                        <h6 onClick={()=>{setstep1(5);settype('')}} className={`px-1.5 py-1.5 w-full text-center cursor-pointer font-[600] rounded text-[11px] ${step1 === 5 ? 'bg-white text-black font-[600]' : 'text-gray-500'}`}>Payment Received</h6>
                    </div>

                    {step1 === 1 &&
                    <div className='mt-6'>  
                        {
                            activityData?.map((a)=>(
                               <div className='border relative border-slate-100 bg-white p-2'>


                                <AiOutlineEdit size={20} className='absolute right-3 top-1.5 bg-slate-100 z-40 p-1 rounded-full' onClick={()=>{setselected_Activity(a);setupdateActivity(true)}} />
                                <AiOutlineDelete size={20} className='absolute right-10 top-1.5 bg-slate-100 z-40 p-1 rounded-full' onClick={()=>{deletemyactivity(a)}} />
                                {!['',null,undefined]?.includes(a?.attachment) &&
                                <AiOutlineCloudDownload size={20} className='absolute right-[70px] top-1.5 bg-slate-100 z-40 p-1 rounded-full' onClick={()=>handleDownload(`${process.env.REACT_APP_AWS_IMAGE_URL}${a?.attachment}`,returnfilename(a?.attachment))} />}

                     
                                <div className='flex items-center mb-1'>
                                  <BiDirections size={20} className='bg-slate-100 rounded-[2px] text-slate-500 p-1' />
                                  {<h6 className='text-[11px] ml-1'>Stage : <span className='font-[700]'>{a?.stage?.name}</span></h6>}

                                </div>  

                      

                                <div className='border p-2 border-gray-200 rounded'> 
                                 {!['',null,undefined]?.includes(a?.attachment) && 
                                  <div className='ml-1  flex relative py-1'>
                                      <img src='https://cdn-icons-png.flaticon.com/512/179/179483.png' className='w-5 h-5 object-contain' />
                                      <div className='ml-1 '>
                                      <h6 className='font-[600] text-[11px] break-all'>{returnfilename(a?.attachment)}</h6>
                                      </div>
                                  </div>}

                                  {a?.remarks !== '' && <h6 className='text-[11px] mb-1'>Remarks : <span className='font-[700]'>{a?.remarks}</span></h6>}
                                  {a?.next_hearing_date !== undefined && <h6 className='text-[11px] mb-2'>Next Hearing Date : <span className='font-[700]'>{moment(a?.next_hearing_date)?.format('LL')}</span></h6>}
                                  
                                  {a?.summary !== '' && <h6 className='text-[11px] mb-1'>Summary : <span className='font-[700]'>{a?.summary}</span></h6>}
                                  {a?.important && <h6 className='text-[9px] my-2'><span className='font-[700] bg-green-400 p-1'>Activity Marked As Important</span></h6>}
                                  
                                  <h6 className='text-[9px] bg-slate-100 my-1 p-1'>Created At : {moment(a?.createdAt)?.format('LLL')}</h6>
                                </div>

                                <h6 className='text-[11px] mt-1.5 flex items-center z-50'><span className='bg-slate-100 p-2 h-5 flex rounded-full items-center font-[700] uppercase' >{a?.created_by?.name?.slice(0,1)}</span> <span className='font-[700] ml-1'>{a?.created_by?.name} / {a?.created_by?.phone}</span></h6>
                                 
                               </div>  
                            ))
                        }
                    </div> 
                    }
                    
                    {step1 === 2 &&
                    <div>
                      <span onClick={()=>{setvisible(true)}} className='absolute top-14 md:top-12 right-[12px]  rounded  bg-slate-300 flex shadow text-gray-900 items-center p-1 text-[11px] font-[700] cursor-pointer'> <LuAlarmClock size={16} className='mr-1' /> Add Reminder</span>
                      <div className='grid mt-12 grid-cols-2 md:grid-cols-3 gap-1'> 
                        {
                            reminderData?.map((a)=>(
                               <div className='border border-slate-100 bg-white p-1'>
                              
                                <h6 className='text-[11px] break-all'>Title : <span className='font-[700]'>{a?.title}</span></h6>
                                <h6 className='text-[11px] break-all'>Description : <span className='font-[700]'>{a?.description}</span></h6>
                                <h6 className='text-[11px] break-all'>Reminder Schedule On : <span className='text-[10px] font-[700]'>{moment(a?.on_date_time)?.format('LLL')}</span></h6>
                                <h6 className='text-[9px] bg-slate-100 my-1 p-1'>Created At : {moment(a?.createdAt)?.format('LLL')}</h6>
                               </div>  
                            ))
                        }
                        </div>                 
                    </div>}

                    {step1 === 3 &&
                    <div>
                        <span onClick={()=>{setattachment({...attachment,type:'notes'});setvisible(true)}} className='absolute right-[12px] top-14 md:top-12 rounded  bg-slate-300 flex shadow text-gray-900 items-center p-1 text-[11px] font-[700] cursor-pointer'> <LuAlarmClock size={16} className='mr-1' /> Add Notes </span>
                        <div className='grid mt-12 grid-cols-2 md:grid-cols-3 gap-1'> 
                        {
                            attachmentData?.map((a)=>(
                               <div className='border border-slate-100 bg-white p-1'>
                                {a?.type === "notes" &&
                                <>
                                    <h6 className='text-[11px] break-all'>Title : <span className='font-[700]'>{a?.title}</span></h6>
                                    <h6 className='text-[11px] break-all'>Description : <span className='font-[700]'>{a?.description}</span></h6>
                                </>}
                                {a?.type === "attachment" &&
                                <>
                                    <h6 className='text-[11px] break-all'>File : <span className='font-[700] underline text-[10px] text-[#1b3f69] cursor-pointer' onClick={()=>handleDownload(`${process.env.REACT_APP_AWS_IMAGE_URL}${a?.file}`,returnfilename(a?.file))}> {a?.file?.split('/')[a?.file?.split('/')?.length - 1]}</span></h6>
                                    <h6 className='text-[11px] break-all'>Name : <span className='font-[700]'>{a?.name}</span></h6>
                                </>}


                                <h6 className='text-[9px] bg-slate-100 my-1 p-1'>Created At : {moment(a?.createdAt)?.format('LLL')}</h6>
                               </div>  
                            ))
                        }
                        </div>
                    </div>}

                    {step1 === 4 &&
                    <div>
                        <span onClick={()=>{setvisible(true)}} className='absolute right-[12px] top-14 md:top-12   rounded  bg-slate-300 flex shadow text-gray-900 items-center p-1 text-[11px] font-[700] cursor-pointer'> <RiBillLine size={16} className='mr-1' /> Add Bill</span>
                        {bills?.map((d,i)=>(  
                            <div className='border border-slate-100 bg-white  mt-12 relative'>
                            <div className={`mx-2 z-20 w-[97%] bg-white p-2 rounded-md relative`}>
                                {(d?.file !== null && d?.file !== undefined && d?.file !== '') && <AiOutlineCloudDownload size={24} className='absolute right-0 z-50 top-1.5 bg-slate-100 p-1 rounded-full' onClick={()=>handleDownload(`${process.env.REACT_APP_AWS_IMAGE_URL}${d?.file}`,returnfilename(d?.file))}/>}
                                <MdPayment  onClick={()=>{setvisible(true);setstep1(5);setpayment({...payment,bill:d})}}  size={24} className='absolute right-[40px] z-50 top-1.5 bg-slate-100 p-1 rounded-full' />

                                {(d?.file !== null && d?.file !== undefined && d?.file !== '') &&
                                    <>

                                        <div className='ml-1 mt-1 border-slate-100  flex relative py-1'>
                                            <img src='https://cdn-icons-png.flaticon.com/512/179/179483.png' className='w-5 h-5 object-contain' />
                                            <div className='ml-1 -mt-0.5'>
                                            <h6 className='font-[600] text-[11px] w-[95%]'>{returnfilename(d?.file)}</h6>
                                            </div>
                                        </div>
                                        <h6 className='text-[11px] pl-1  '>Amount  : <span className='font-[700]'>{rupee.format(d?.amountWithoutGst)}</span></h6>
                                        <h6 className='text-[11px] pl-1 border-b pb-2 border-slate-100'>Raised Request Date  : <span className='font-[700]'>{d?.date !== undefined && moment(d?.date)?.format('LL')}</span></h6>

                                        <>
                                            <h6 className='text-[11px]  mt-2 pl-1 font-[800]'>Employee Info : <span className='font-[700] text-[11px] p-1 bg-slate-100'>{d?.created_by?.name}</span></h6> 
                                        </>

                                        <>
                                            <h6 className='text-[11px] border-t pt-2 border-slate-100 mt-2 pl-1 font-[800]'>Bill Info</h6> 
                                            <h6 className='text-[11px] pl-1 mt-2'>Bill Id  : <span className='font-[700]'>{d?.bill_id}</span></h6>
                                            <h6 className='text-[11px] pl-1 '>Bill Info  : <span className='font-[700]'>{d?.bill_info}</span></h6>
                                            <h6 className='text-[11px] pl-1 '>Amount Incl GST  : <span className='font-[700]'>{rupee.format(d?.amountWithGst)?.split('.')[0]}</span></h6>
                                            <h6 className='text-[11px] pl-1 '>Amount Excl GST  : <span className='font-[700]'>{rupee.format(d?.amountWithoutGst)?.split('.')[0]}</span></h6>
                                        </>
                                    
                                    </>
                                    }
                            </div> 
                            </div>))}
                    </div>}

                    {step1 === 5 &&
                    <div>
                        {/* <span onClick={()=>{setattachment({...attachment,type:'notes'});setvisible(true)}} className='absolute right-[12px] top-12   rounded  bg-slate-300 flex shadow text-gray-900 items-center p-1 text-[11px] font-[700] cursor-pointer'> <LuAlarmClock size={16} className='mr-1' /> Add Notes / Attachments</span> */}
                        <div className='grid mt-12 grid-cols-2 md:grid-cols-3 gap-1'> 
                        {
                            payments?.map((a)=>(
                               <div className='border border-slate-100 bg-white p-1'>
                             
                                <h6 className='text-[11px]'>Amount With Gst : <span className='font-[700]'>{rupee?.format(a?.amountWithoutGst)}</span></h6>
                                <h6 className='text-[11px]'>Amount Without Gst : <span className='font-[700]'>{rupee?.format(a?.amountWithoutGst)}</span></h6>
                                <h6 className='text-[11px] mt-1 pt-1 border-t mt-1 border-slate-100'>Record added by : <span className='font-[700]'>{a?.created_by?.name}</span></h6>



                                <h6 className='text-[9px] bg-slate-100 my-1 p-1'>Created At : {moment(a?.date)?.format('LLL')}</h6>
                               </div>  
                            ))
                        }
                        </div>
                    </div>}


                </div>

                <div className='md:min-w-[20%] py-2 px-2 md:max-w-[20%] md:min-h-screen md:max-h-screen md:border-l'>

                    <h6 className='text-[13px] font-[700] mt-2'>Work Info</h6>
                    
                    <div className='bg-slate-100 p-2 mt-2'>
                      <h6 className='w-[100%] text-[11px]'>Details : <span className='text-[10px]'>{data?.work_details}</span></h6>
                      <h6 className='w-[100%] text-[11px]'>Office File No : <span className='text-[10px] font-[700]'>{data?.office_file_no}</span></h6>
                      <h6 className='w-[100%] text-[11px]'>Case No : <span className='text-[10px] font-[700]'>{data?.case_no}</span></h6>
                      <h6 className='w-[100%] text-[10px] mt-1'>Status : <span className='text-[10px] font-[700]'>{data?.status}</span></h6>
                      {/* <h6 className='w-[100%] text-[10px] mt-1'>Download File : <span className='text-[10px] font-[700]'>{data?.file}</span></h6> */}
                      {(data?.file !== '' && data?.file !== null && data?.file !== undefined && data?.file !== 'null' && data?.file !== 'undefined') &&
                        <h6 className='w-[100%] text-[10px] mt-1 cursor-pointer'>Download File : <span onClick={()=>handleDownload(`${process.env.REACT_APP_AWS_IMAGE_URL}${data?.file}`,returnfilename(data?.file))}  className='text-[10px] underline font-[700]'>{data?.file}</span></h6>}
                 
                    </div>

                    <div className='p-2 '>
                      <h6 className='w-[100%] text-[10px] mt-1'>Parties Name : <span className='text-[10px] font-[700]'>{data?.parties_name}</span></h6>
                      <h6 className='w-[100%] text-[10px] mt-1'>Advocate For : <span className='text-[10px] font-[700]'>{data?.advocate_for}</span></h6>
                      <h6 className='w-[100%] text-[10px] mt-1'>Court Hall : <span className='text-[10px] font-[700]'>{data?.court_hall}</span></h6>
                      <h6 className='w-[100%] text-[10px] mt-1'>Floor : <span className='text-[10px] font-[700]'>{data?.floor}</span></h6>
                      <h6 className='w-[100%] text-[10px] mt-1'>File : <span className='text-[10px] cursor-pointer font-[700] break-all underline'>{data?.file}</span></h6>
                      <h6 className='w-[100%] text-[10px] mt-1'>Stage : <span className='text-[10px] font-[700]'>{data?.stage?.name}</span></h6>
                    </div>

                    <h6 className='text-[13px] pt-2 border-t font-[700] mt-2'>Created Person </h6>

                    <h6 className='w-[100%] mt-2 text-[11px]'>Employee Info : <span className='text-[10px] capitalize font-[700]'>{data?.created_by?.name}</span></h6>
                    <h6 className='w-[100%] text-[11px]'>Comments : <span className='text-[10px]'>{data?.comments}</span></h6>


                    
                </div>
            
            </div>
        </div>
    </div>
  )
}

export default CaseDetail